import FooterSectionCTA from './FooterSectionCTA';

export default FooterSectionCTA;
